import { makeStyles } from "@material-ui/core"

const styles = makeStyles((theme) => ({
  formContainer: {
    backgroundColor: "#092958",
    width: "477px",
    height: "502px",
    borderRadius: "4px 4px 4px 4px",
  },
  formMobile: {
    backgroundColor: "#092958",
    width: "100%",
    height: "100%",
  },
  logo: {
    marginBottom: theme.spacing(6),
  },
}))

export default styles
